'use client'

import { useState } from 'react'
import { landingpage_skills_footer_copy_click } from '@/constants/trace'
import { trackEvent } from '@/lib/utils'
import { CopyIcon, SkillHeroActionButton } from './skill-hero-section'
import { allSkillPrompt } from './skill-data'
import { copySkillText } from './skill-copy'

// 底部 CTA 只负责自己的复制反馈，避免把顶部 Hero 的状态绑到整页。
export function SkillFooterCTASection() {
  const [copied, setCopied] = useState(false)

  const handleCopyAll = async () => {
    trackEvent(landingpage_skills_footer_copy_click)
    const success = await copySkillText(allSkillPrompt)

    if (!success) {
      setCopied(false)
      return
    }

    setCopied(true)
    window.setTimeout(() => {
      setCopied(false)
    }, 1600)
  }

  return (
    <section className="relative mx-auto mt-20 flex min-h-[280px] w-full max-w-[1920px] items-center justify-center overflow-hidden bg-[linear-gradient(90deg,rgba(255,255,255,0.4)_0%,rgba(255,255,255,0.4)_100%),radial-gradient(circle_at_38%_136%,rgba(207,175,255,0.95)_0%,rgba(207,175,255,0)_35%),radial-gradient(circle_at_61%_138%,rgba(142,225,255,0.75)_0%,rgba(142,225,255,0)_33%)] px-4 sm:mt-24 sm:min-h-[320px] sm:px-8 xl:mt-[150px] xl:h-[348px] xl:px-24">
      <div className="absolute bottom-[-40px] right-[-24px] h-[120px] w-[120px] rounded-full bg-[radial-gradient(circle_at_34%_24%,rgba(255,255,255,0.98),rgba(136,121,255,0.36)_40%,rgba(109,255,222,0.72)_76%,rgba(255,255,255,0.34)_100%)] sm:bottom-[-56px] sm:right-[-18px] sm:h-[150px] sm:w-[150px] xl:bottom-[-72px] xl:right-[-12px] xl:h-[180px] xl:w-[180px]" />
      <div className="relative z-10 flex w-full max-w-[420px] flex-col items-center gap-5 text-center sm:gap-6">
        <SkillHeroActionButton
          onClick={handleCopyAll}
          copied={copied}
          primary
          icon={<CopyIcon />}
        >
          复制全部技能安装提示词
        </SkillHeroActionButton>
        <p className="text-[14px] leading-[1.6] text-[#898FA7] sm:text-[16px] xl:text-[20px] xl:leading-[20px]">复制提示词 → 发给你的小龙虾 → 自动学会</p>
      </div>
    </section>
  )
}
